import { render, staticRenderFns } from "./CoinCard.vue?vue&type=template&id=261028b2&"
import script from "./CoinCard.vue?vue&type=script&lang=js&"
export * from "./CoinCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports